export default [0, 4, 8, 16, 28, 32, 64, 70, 160]